<template>
  <v-card>
    <SelectWifiDialog ref="dialog" />

    <ODialogBar no-close title="Configuração Wifi">
      <v-btn icon @click="reload" class="ml-2">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn icon @click="editNetworks">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>

    <OLoadingLine :value="isLoading" />

    <v-card-text class="pa-0 d-flex flex-row flex-wrap">
      <v-list two-line class="w-full ma-0 pa-0">
        <OListItem v-for="net in networks" :key="net.id" v-bind="net" />
      </v-list>

      <OAlert info class="w-full ma-6" v-if="networks.length == 0">
        Este veículo não está associado a nenhuma rede Wifi.
      </OAlert>

      <OAlert warning class="w-full ma-6" v-if="networks.length > 5">
        Atenção! O módulo aceita no máximo 5 redes wifi. Apenas as
        primeiras 5 da lista acima serão embarcadas!
      </OAlert>

      <OAlert error class="w-full ma-6" v-if="errMessage != null">
        Houve um erro ao recuperar as redes wifi deste módulo:
        {{ errMessage }}
      </OAlert>
    </v-card-text>
  </v-card>
</template>

<script>
import { WifiAssoc } from '../../../models/wifi'
import SelectWifiDialog from './SelectWifiDialog.vue'
import OListItem from 'oderon-vue/cpts/lists/OListItem.vue'

export default {
  expose: ['reload'],
  components: { SelectWifiDialog, OListItem },
  props: {
    vehicle: { required: true }
  },
  data() {
    return { isLoading: false, errMessage: null, networks: [] }
  },
  mounted() {
    this.reload()
  },
  watch: {
    vehicle() {
      this.reload()
    }
  },
  computed: {
    noneSelected() {
      return this.networks.every((x) => x.isSelected == false)
    }
  },
  methods: {
    reload() {
      this.$loadingQuiet(() => this.fetchData())
    },
    async fetchData() {
      this.$delay(1000)
      let assocs = await WifiAssoc.findByVehicle(this.vehicle.id)
      assocs = assocs.map((a) => {
        return {
          id: a.id,
          leftIcon: 'mdi-wifi',
          title: a.network.name,
          subtitle: a.network.tags,
          rightChip: a.network.ssid
        }
      })
      this.networks = assocs
    },

    async editNetworks() {
      let res = await this.$refs.dialog.open(this.vehicle.id)
      if (res === true) {
        this.reload()
        this.$emit('reload') // causa reload no embedStatus
      }
    }
  }
}
</script>

<style></style>
